
import React, { useEffect } from 'react';
import { useAuth } from '@/contexts/auth';
import { updateUserActivity } from '@/contexts/auth/functions/organization';

/**
 * Composant qui suit l'activité de l'utilisateur et met à jour son timestamp de dernière activité
 */
export const DashboardActivityTracker: React.FC = () => {
  const { getCurrentOrganization } = useAuth();
  
  useEffect(() => {
    const trackActivity = async () => {
      try {
        const organization = await getCurrentOrganization();
        if (organization?.id) {
          // Mettre à jour l'activité au chargement initial
          await updateUserActivity(organization.id);
          
          // Mettre à jour l'activité périodiquement (toutes les 5 minutes)
          const intervalId = setInterval(async () => {
            await updateUserActivity(organization.id);
          }, 5 * 60 * 1000);
          
          // Nettoyer l'intervalle lors du démontage du composant
          return () => clearInterval(intervalId);
        }
      } catch (error) {
        console.error('Erreur lors du suivi d\'activité:', error);
      }
    };
    
    trackActivity();
  }, [getCurrentOrganization]);
  
  // Ce composant ne rend rien, il fonctionne en arrière-plan
  return null;
};
